//
//
//
//
//

import {inject as RegistrableInject} from "../../mixins/Registrable";

export default {
    name: 'SliderItem',

    mixins: [RegistrableInject('slider')],

    props: {

        // The unique value to identify the slider item
        // Defaults to the DOM hierarchy index
        value: {
            type: [String, Number],
            default: null
        }
    },

    created() {
        this.slider && this.slider.register(this)
    },

    beforeDestroy() {
        this.slider && this.slider.unregister(this)
    },
}
